// @flow

import * as React from 'react';
import { Closer, Global } from '@ta/overlays.managers';
import ModalView, { type OuterProps as ViewProps } from './ModalView';

/** The props passed into <Modal/> */
export type Props = {|
  /** Globally unique name for this modal. You'll then be able to open the modal by name */
  name: string,
  /** The props that dictate the view of the Modal */
  ...ViewProps,
|};

/**
 * @deprecated  Use @ta/modal.styleguide instead
 */
const Modal = ({ name, onClose, ...viewProps }: Props) => (
  <Closer>
    {close => {
      /* istanbul ignore next */
      const closer = () => {
        close();
        if (onClose) {
          onClose();
        }
      };
      return (
        <Global name={name}>
          <ModalView onClose={closer} {...viewProps} />
        </Global>
      );
    }}
  </Closer>
);

export default Modal;
